import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';

const initialState = {
    general: {
        backgroundColor: '#FFFFFF'
    },
    primaryText: {
        size: '16px',
        color: '#000000',
        hoverColor: '#23826F',
        style: 'normal',
        weight: 'bold',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex sans'
    },
    defaultLink: {
        color: '#5ed4bc',
        hoverColor: '#23826F'
    }
};

const filterBarDataReducer = handleActions(
    {
        [ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], font: action.font };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_SIZE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], size: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_WEIGHT]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_HOVER_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], hoverColor: action.hoverColor };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_STYLE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_DECORATION]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], decoration: action.decoration };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_ALIGN]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], align: action.align };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_LINE_HEIGHT]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], lineHeight: action.lineHeight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_GENERAL_BACKGROUND_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], backgroundColor: action.backgroundColor };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_DEFAULT_LINK_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_FILTER_BAR_SET_DEFAULT_LINK_HOVER_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], hoverColor: action.hoverColor };
            return { ...state, ...obj };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('filterbar')) {
                return { ...state, filterbar: action.theme.filterbar };
            } else {
                return state;
            }
        }
    },
    initialState
);

export default filterBarDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/filterbar.js